/**
 * 주소에 쓰는 영상 식별자.
 *
 * 학습자 화면은 `/watch/squid-game-mugunghwa` 처럼 slug 를 쓴다 — PWA 로 설치하면
 * 주소창이 없지만 브라우저로 쓰는 사용자에게는 그대로 보인다. 어드민만 UUID 를
 * 노출할 이유가 없어(`/admin/vod/11111111-…-0001/review`) 같은 규칙을 쓴다.
 *
 * slug 가 없는 영상(초안)도 있으므로 id 로 폴백하고, 조회하는 쪽은 둘 다 받는다.
 * 그래서 이미 나가 있는 UUID 링크도 깨지지 않는다.
 */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isUuid(value: string): boolean {
  return UUID_RE.test(value)
}

export function videoKey(video: { id: string; slug?: string | null }): string {
  return video.slug ?? video.id
}

/**
 * 사람이 입력한 값을 slug 로 다듬는다.
 *
 * 한글은 **버린다.** 로마자 변환 규칙을 넣으면 '무궁화' → 'mugunghwa' 는 되지만
 * '오징어 게임' → 'ojingeo-geim' 처럼 아무도 검색하지 않을 문자열이 나온다.
 * 영문 제목에서 만들거나 사람이 직접 적는 편이 낫다 — 그래서 한글만 있으면 빈 문자열이
 * 되고, 화면은 "영문 제목을 채우거나 직접 적으세요"로 안내한다.
 */
export function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)
    .replace(/-+$/g, '')
}

/** 저장해도 되는 slug 인지. 빈 값(=null 로 저장)은 호출부에서 따로 다룬다. */
export function isValidSlug(value: string): boolean {
  return /^[a-z0-9]+(-[a-z0-9]+)*$/.test(value) && value.length <= 60
}
